import SelectFilter from '~/client/shared/game/Filters/SelectFilter';
import FiltersContainer from './FiltersContainer';
import SortFilter from '../../Filters/SortFilter';

type Props = {
  pageSection: PageSection;
  isLiveRtp?: boolean;
  menuItem?: string;
  theme?: string;
  isProviderFilterVisible?: boolean;
  isCategoryFilterVisible?: boolean;
};

const SHOW_CATEGORIES: PageSection[] = ['main', 'providers', 'themes'];

const GameFilters: FC<Props> = ({
  pageSection,
  isLiveRtp,
  menuItem,
  theme,
  isProviderFilterVisible,
  isCategoryFilterVisible,
}) => (
  <FiltersContainer pageSection={pageSection}>
    {isCategoryFilterVisible && SHOW_CATEGORIES.includes(pageSection) && (
      <SelectFilter type="categories" menuItem={menuItem} theme={theme} />
    )}
    {isProviderFilterVisible && pageSection !== 'providers' && (
      <SelectFilter type="providers" menuItem={menuItem} theme={theme} />
    )}
    <SortFilter isLiveRtp={isLiveRtp} />
  </FiltersContainer>
);

export default GameFilters;
